import React, { ReactElement } from "react"
import { Text } from "@chakra-ui/react"
import { OptionTitle } from "../../utils/OptionTitle"
import { getOptionTitlesFromArray } from "../../utils/AnswerUtils"

export function Answer({ children }: { children: string } | { children: string[] }): ReactElement {
  return children ? <Text>{children}</Text> : <NoAnswer />
}

function NoAnswer(): ReactElement {
  return (
    <Text color="gray.400" fontStyle="italic">
      N/A
    </Text>
  )
}

function NoneSelected(): ReactElement {
  return (
    <Text color="gray.400" fontStyle="italic">
      None selected
    </Text>
  )
}

type AnswersListProps = {
  optionTitles: Array<OptionTitle>
  answers: Array<string>
}
export function AnswerList({ optionTitles, answers }: AnswersListProps): ReactElement {
  return !answers ? (
    <NoAnswer />
  ) : answers?.length === 0 ? (
    <NoneSelected />
  ) : (
    <AnswerListInner optionTitles={optionTitles} answers={answers} />
  )
}

export function AnswerListInner({ optionTitles, answers }: AnswersListProps): ReactElement {
  const optionsTitles = getOptionTitlesFromArray(optionTitles, answers)
  return (
    <>
      {optionsTitles.map((answer, i) => (
        <Answer key={i}>{answer}</Answer>
      ))}
    </>
  )
}

export type SkippableAnswerProps = {
  questionKey: string
  skipFields?: Array<string>
  children?: React.ReactNode
}

export function SkippableAnswer({ questionKey, skipFields, children }: SkippableAnswerProps): ReactElement {
  if (skipFields?.includes(questionKey)) {
    return <SkippedAnswerDisplay />
  }
  return <>{children}</>
}

export function SkippedAnswerDisplay(): ReactElement {
  return (
    <Text className="answer" color="gray.400" fontStyle="italic">
      Skipped
    </Text>
  )
}
